import React from 'react';
import { Box, Typography } from '@mui/material';
import { CHECK_IN_COLORS } from './colors';

interface CheckInTabsProps {
  tabs: { id: string; label: string }[];
  activeId: string;
  onChange: (id: string) => void;
}

export const CheckInTabs: React.FC<CheckInTabsProps> = ({
  tabs,
  activeId,
  onChange,
}) => {
  const activeIndex = Math.max(
    0,
    tabs.findIndex(t => t.id === activeId),
  );
  const tabWidthPct = 100 / tabs.length;

  return (
    <Box
      sx={{
        display: 'flex',
        height: '48px',
        width: '100%',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      {tabs.map(tab => {
        const active = tab.id === activeId;
        return (
          <Box
            key={tab.id}
            onClick={() => onChange(tab.id)}
            sx={{
              flex: 1,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: active ? 600 : 500,
                fontSize: '14px',
                lineHeight: '21px',
                color: active ? CHECK_IN_COLORS.navy : CHECK_IN_COLORS.muted,
                whiteSpace: 'nowrap',
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: '47px',
          width: '100%',
          height: '1px',
          backgroundColor: CHECK_IN_COLORS.hairline,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '46px',
          left: `${activeIndex * tabWidthPct}%`,
          width: `${tabWidthPct}%`,
          height: '2px',
          backgroundColor: CHECK_IN_COLORS.navy,
          transition: 'left 120ms ease',
        }}
      />
    </Box>
  );
};
